import React from 'react';
import propTypes from 'prop-types';
export const RulesLinkIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g id="surface1">
        <path
          stroke="none"
          fillRule="nonzero"
          fill={color}
          fillOpacity="1"
          d="M 15.3125 8.6875 C 18.109375 11.492188 18.070312 15.988281 15.328125 18.75 C 15.320312 18.753906 15.316406 18.761719 15.3125 18.765625 L 12.160156 21.914062 C 9.382812 24.695312 4.859375 24.695312 2.085938 21.914062 C -0.695312 19.140625 -0.695312 14.617188 2.085938 11.839844 L 3.820312 10.101562 C 4.285156 9.640625 5.078125 9.945312 5.101562 10.597656 C 5.132812 11.429688 5.28125 12.265625 5.554688 13.070312 C 5.648438 13.34375 5.585938 13.644531 5.378906 13.847656 L 4.765625 14.460938 C 3.453125 15.773438 3.410156 17.914062 4.710938 19.242188 C 6.023438 20.578125 8.183594 20.585938 9.507812 19.265625 L 12.65625 16.117188 C 13.980469 14.792969 13.976562 12.65625 12.65625 11.34375 C 12.484375 11.167969 12.3125 11.035156 12.171875 10.9375 C 11.976562 10.804688 11.859375 10.585938 11.847656 10.351562 C 11.828125 9.851562 12.003906 9.34375 12.398438 8.953125 L 13.382812 7.964844 C 13.640625 7.707031 14.046875 7.671875 14.347656 7.882812 C 14.691406 8.125 15.015625 8.394531 15.3125 8.6875 Z M 21.914062 2.085938 C 19.140625 -0.695312 14.617188 -0.695312 11.839844 2.085938 L 8.6875 5.234375 C 8.683594 5.238281 8.679688 5.246094 8.671875 5.25 C 5.929688 8.011719 5.890625 12.507812 8.6875 15.3125 C 8.984375 15.605469 9.308594 15.875 9.652344 16.117188 C 9.953125 16.328125 10.359375 16.292969 10.617188 16.035156 L 11.601562 15.046875 C 11.996094 14.65625 12.171875 14.148438 12.152344 13.648438 C 12.140625 13.414062 12.023438 13.195312 11.828125 13.0625 C 11.6875 12.964844 11.515625 12.832031 11.34375 12.65625 C 10.023438 11.34375 10.019531 9.207031 11.34375 7.882812 L 14.492188 4.734375 C 15.8125 3.414062 17.976562 3.421875 19.289062 4.757812 C 20.589844 6.085938 20.546875 8.226562 19.234375 9.539062 L 18.621094 10.152344 C 18.414062 10.355469 18.351562 10.65625 18.445312 10.929688 C 18.71875 11.734375 18.867188 12.570312 18.898438 13.402344 C 18.921875 14.054688 19.714844 14.359375 20.179688 13.898438 L 21.914062 12.160156 C 24.695312 9.382812 24.695312 4.859375 21.914062 2.085938 Z M 21.914062 2.085938 "
        />
      </g>
    </svg>
  );
};
RulesLinkIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
RulesLinkIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
